import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";
import moment from "moment";
import {
  retrieveUserCompanies,
  retrieveUserDetails,
} from "../../../../redux/actions/user";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import lightLogo from "../../../../img/logo-light.png";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import {
  requestFinalizeRegistration,
  requestFinalizeResubscription,
  requestNewSpaceRegistration,
  resetFinalizeRegistration,
} from "../../../../redux/actions/registration";
import { auth } from "../../../../networking/firebase";
import LoadingView from "../loading-view";
import FailedView from "../failed-view";
import SuccessView from "../success-view";
import "./style.scss";

const Index = (props) => {
  const dispatch = useDispatch();

  const callbackId = props.match.params.id;
  const [view, setView] = useState("loading");

  const registerError = useSelector(
    (state) => state.registration.validateLastStep.error
  );
  const registerLoading = useSelector(
    (state) => state.registration.validateLastStep.loading
  );
  const registerStatus = useSelector(
    (state) => state.registration.validateLastStep.status
  );

  const [errorMessage, setErrorMessage] = useState({
    title: "",
    description: "",
    icon: null,
  });

  const [tabs, _] = useState([
    {
      name: "Kontodetaljer",
      name_mobile: "Detaljer",
      description: "Kort om deg selv",
      icon: <i class="fas fa-user"></i>,
      active: false,
    },
    {
      name: "Start prøveperiode",
      name_mobile: "Prøveperiode",
      description: "Betalingsinformasjon",
      icon: <i class="fad fa-hourglass-start"></i>,
      active: false,
    },
    {
      name: "Kom i gang",
      name_mobile: "Kom i gang",
      description: "Gå til dashboard",
      icon: <i class="fad fa-check-double"></i>,
      active: true,
    },
  ]);

  const validateSession = async (id) => {
    try {
      const details = await fetch(
        `/api/stripe/checkout-session?sessionId=${callbackId}`
      );
      const result = await details.json();
      if (!result.error) {
        if (
          Object.keys(result).length > 0 &&
          result.status &&
          result.status === "complete"
        ) {
          const type = result && result.metadata && result.metadata.type;
          switch (type) {
            case "signup":
              dispatch(
                requestFinalizeRegistration({
                  customerId: result.customer,
                  organizationNumber: result.metadata.organizationNumber,
                  setupIntent: result.setup_intent,
                  subscriptionId: result.subscription,
                  sessionId: result.id,
                  email: auth.currentUser?.email,
                  uid: auth.currentUser?.uid,
                  timestamp: moment(Date.now()).unix(),
                })
              );
              break;
            case "resubscribe":
              dispatch(
                requestFinalizeResubscription({
                  customerId: result.customer,
                  companyId: result.metadata.companyId,
                  subscriptionId: result.subscription,
                  setupIntent: result.setup_intent,
                  sessionId: result.id,
                  email: auth.currentUser?.email,
                  uid: auth.currentUser?.uid,
                  timestamp: moment(Date.now()).unix(),
                })
              );
              break;
            case "newspace":
              dispatch(
                requestNewSpaceRegistration({
                  customerId: result.customer,
                  organizationNumber: result.metadata.organizationNumber,
                  setupIntent: result.setup_intent,
                  subscriptionId: result.subscription,
                  sessionId: result.id,
                  email: auth.currentUser?.email,
                  uid: auth.currentUser?.uid,
                  timestamp: moment(Date.now()).unix(),
                })
              );
              break;
            default:
              break;
          }
        }
      } else {
        throw "Abonnering feilet.";
      }
    } catch (e) {
      setView("failed");
      setErrorMessage({
        title: "Kunne ikke gjennomføre oppsett",
        description:
          "Det skjedde en uventet feil i prosessen med å ferdigstille miljøet for bedriften din.",
        icon: <i class="fad fa-times"></i>,
      });
      dispatch(resetFinalizeRegistration());
    }
  };

  useEffect(() => {
    if (callbackId && callbackId === "feil") {
      setView("failed");
      setErrorMessage({
        title: "Betaling kunne ikke gjennomføres",
        description:
          "Betaling ble ikke gjennomført, men du kan likevel gå videre til dashboardet og prøve på nytt senere.",
        icon: <i class="fad fa-times"></i>,
      });
      dispatch(resetFinalizeRegistration());
    }
    if (callbackId && callbackId !== "feil") {
      validateSession();
    }
  }, [callbackId]);

  useEffect(() => {
    if (!registerLoading && registerError) {
      switch (registerError.code) {
        case 0:
          setView("failed");
          setErrorMessage({
            title: "Miljøet ditt er allerede satt opp",
            description:
              "Det ser ut som du prøver å sette opp et miljø som allerede er blitt satt opp.",
            icon: <i class="fad fa-pastafarianism"></i>,
          });
          dispatch(resetFinalizeRegistration());
          break;
        default:
          setView("failed");
          setErrorMessage({
            title: "En uventet feil oppstod",
            description:
              "Kunne ikke fortsette prosessen med å registrere betaling, vennligst kontakt kundeservice.",
            icon: <i class="fad fa-pastafarianism"></i>,
          });
          dispatch(resetFinalizeRegistration());
          break;
      }
      dispatch(retrieveUserDetails(auth?.currentUser?.uid));
    }
  }, [registerError, registerLoading]);

  useEffect(() => {
    if (!registerLoading && registerStatus === "success") {
      setView("success");
      dispatch(retrieveUserDetails(auth?.currentUser?.uid));
    }
  }, [registerStatus, registerLoading]);

  const determineViewRender = () => {
    switch (view) {
      case "loading":
        return <LoadingView />;
      case "failed":
        return <FailedView errorMessage={errorMessage} />;
      case "success":
        return <SuccessView />;
      default:
        return null;
    }
  };

  return (
    <section className="final-register-page-section">
      <div className="inner-register-page-container">
        <div className="full-content-container">
          <div className="register-display-container">
            <div className="register-box-container">
              <div className="inner-register-box-container">
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                  <Row className="register-row">
                    <Col md className="menu-col">
                      <Link to="/">
                        <img
                          className="menu-logo"
                          alt="Leadfind logo"
                          src={lightLogo}
                        />
                      </Link>
                      <h3 className="register-title">Opprett ny konto</h3>
                      <p className="register-description">
                        Det går fortere enn du tror, registrering tar under ett
                        minutt.
                      </p>
                      <Nav
                        variant="pills"
                        className="flex-column menu-navigation desktop"
                      >
                        {tabs.map((tab) => {
                          return (
                            <Nav.Item>
                              <Nav.Link active={tab.active}>
                                <div
                                  className={`single-step-container ${
                                    tab.active ? "active" : ""
                                  }`}
                                >
                                  <Row className="step-row">
                                    <Col className="icon-col my-auto">
                                      <div className="step-container">
                                        <span className="icon">{tab.icon}</span>
                                      </div>
                                    </Col>
                                    <Col className="data-col my-auto">
                                      <span className="step-title">
                                        {tab.name}
                                      </span>
                                      <span className="step-description">
                                        {tab.description}
                                      </span>
                                    </Col>
                                  </Row>
                                  <span className="active-indicator" />
                                </div>
                              </Nav.Link>
                            </Nav.Item>
                          );
                        })}
                      </Nav>
                      <Nav className="menu-navigation mobile">
                        <Row className="mobile-menu-row">
                          {tabs.map((tab) => {
                            return (
                              <Col
                                className={`outer-step-container text-center ${
                                  tab.active ? "active" : ""
                                }`}
                              >
                                <Col className="inner-step-container">
                                  <div className="icon-container text-center">
                                    <span className="icon">{tab.icon}</span>
                                  </div>
                                  <div className="title-container">
                                    <span className="step-title">
                                      {tab.name_mobile}
                                    </span>
                                  </div>
                                  {tab.active ? (
                                    <div className="separator" />
                                  ) : null}
                                </Col>
                              </Col>
                            );
                          })}
                        </Row>
                      </Nav>
                    </Col>
                    <Col md className="display-col">
                      <div className="inner-tab-container">
                        {determineViewRender()}
                      </div>
                    </Col>
                  </Row>
                </Tab.Container>
              </div>
            </div>
            <div className="links-container">
              <Link to="/">Leadfind.no</Link>
              <span className="circle-separator">
                <i class="fas fa-circle"></i>
              </span>
              <Link to="/personvern">Personvern</Link>
              <span className="circle-separator">
                <i class="fas fa-circle"></i>
              </span>
              <Link to="/cookies">Cookies</Link>
              <span className="circle-separator">
                <i class="fas fa-circle"></i>
              </span>
              <Link to="/vilkår">Vilkår</Link>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
};

export default withRouter(Index);
